import { PropsWithChildren, ReactNode } from 'react';
import { useIsMobile } from 'shared/hooks';

import ContentCard from './ContentCard';
import { PageLayout } from './PageLayout';

export interface FullPageContentCardProps {
    /**
     * Maximum content width constraint
     * @default 'lg'
     */
    size?: 'sm' | 'md' | 'lg';
    /**
     * Content rendered outside the card on desktop (e.g., page heading).
     * On mobile, rendered inline before children (no card wrapper).
     */
    header?: ReactNode;

    verticallyCenter?: boolean | 'mobileOnly';
}

export default function FullPageContentCard({
    children,
    header,
    verticallyCenter = false,
    size = 'lg'
}: PropsWithChildren<FullPageContentCardProps>) {
    const isMobile = useIsMobile();
    const shouldVerticallyCenter = verticallyCenter === true || (verticallyCenter === 'mobileOnly' && isMobile);

    if (isMobile) {
        return (
            <PageLayout background="paper"
                verticallyCenter={ shouldVerticallyCenter }
            >
                <PageLayout.Content size={ size }>
                    { header }
                    { children }
                </PageLayout.Content>
            </PageLayout>
        );
    }

    return (
        <PageLayout verticallyCenter={ shouldVerticallyCenter }>
            <PageLayout.Content size={ size }>
                { header }
                <ContentCard>
                    { children }
                </ContentCard>
            </PageLayout.Content>
        </PageLayout>
    );
}
